export default "__VITE_ASSET__B9XdKiJ6__"